import { useContext } from "react";
import styles from "./index.module.scss";
import { GenerateContext } from "../../../hooks/GenerateContext";
import { MODEL_EXPRESSION } from "@utils/CONST";

const Emoji = (props) => {
    const { emoji, setEmoji } = useContext(GenerateContext);

    const items = [
        {
            value: MODEL_EXPRESSION.SRC,
            title: "按原模特",
        },
        {
            value: MODEL_EXPRESSION.REF,
            title: "按模特参考图",
        },
    ];

    return (
        <div>
            <p className={styles.titleText}>模特表情</p>
            <div className={styles.Emoji}>
                {items.map((item) => (
                    <div
                        key={item.value}
                        className={`${styles.Item} ${
                            emoji === item.value ? styles.Active : ""
                        }`}
                        onClick={() => setEmoji(item.value)}
                    >
                        {item.title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Emoji;
